import { MoreVert } from "@mui/icons-material";
import { Button, Fade, IconButton, Menu, MenuItem, tabsClasses } from "@mui/material";
import { getBadge } from "components/shared/Tables/helper";
import { formatDateBdata } from "components/utils";
import { DeviceStatus } from "components/utils/enums";
import toast from "react-hot-toast";
import { devicesActions } from "../../../redux/slice/devices.slice";
import { SEND_TWO_FA_OTP } from "../../../redux/types/auth.types";
import ActiveIcon from '../../../static/svgs/active';
import HeldIcon from '../../../static/svgs/held';
import TemporaryIcon from '../../../static/svgs/temporary';
import WarningIcon from '../../../static/svgs/warning';
import tables from "../../shared/Tables/table.module.scss";
import theme from "../../utils/theme";
import { handleOpenBlockHash } from "../Networks/NetworkKeyFeatures/MapSummary/helper";
import { openRemoteConsole } from "../SingleDashboard/helper";


export const getMarker = (color) => {
    return `<div style="
      width: 40px;
      height: 40px;
      border: 2px solid ${color};
      border-radius: 50%;
      background-color : white;
      display: flex;
      justify-content: center;
      align-items: center;
    ">
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.3684 8.50626H5.41697C4.9425 8.50626 4.55603 8.89464 4.55603 9.3672V17.99C4.55603 18.4645 4.94441 18.851 5.41697 18.851H10.3684C10.8428 18.851 11.2293 18.4626 11.2293 17.99V9.3672C11.2293 8.89272 10.8428 8.50626 10.3684 8.50626ZM7.89266 12.8225C7.08146 12.8225 6.42523 12.1662 6.42523 11.355C6.42523 10.5438 7.08338 9.88759 7.89266 9.88759C8.70195 9.88759 9.36009 10.5457 9.36009 11.355C9.36009 12.1643 8.70386 12.8225 7.89266 12.8225Z" fill="${color}"/>
            <path d="M10.3682 8.31468C10.0181 8.31468 9.66797 8.31468 9.31785 8.31468C8.61379 8.31468 7.90782 8.31468 7.20376 8.31468C6.66232 8.31468 6.11897 8.31468 5.57753 8.31468C5.37091 8.31468 5.17384 8.32425 4.98061 8.41225C4.6018 8.58253 4.36647 8.969 4.36456 9.38034C4.36265 9.65392 4.36456 9.92751 4.36456 10.2011C4.36456 10.7827 4.36456 11.3662 4.36456 11.9479C4.36456 12.6691 4.36456 13.3885 4.36456 14.1098C4.36456 14.8005 4.36456 15.4892 4.36456 16.1799C4.36456 16.662 4.36456 17.1422 4.36456 17.6243C4.36456 17.7334 4.36456 17.8444 4.36456 17.9534C4.36456 18.2576 4.4717 18.5542 4.70128 18.7627C4.92704 18.9693 5.20254 19.0459 5.501 19.0459C5.68658 19.0459 5.87025 19.0459 6.05583 19.0459C6.72163 19.0459 7.38934 19.0459 8.05513 19.0459C8.68458 19.0459 9.31594 19.0459 9.94538 19.0459C10.0812 19.0459 10.2171 19.0459 10.3529 19.0459C10.7968 19.0439 11.1909 18.7761 11.3535 18.3609C11.4587 18.0893 11.4205 17.7506 11.4205 17.4655C11.4205 16.9413 11.4205 16.419 11.4205 15.8948C11.4205 15.1927 11.4205 14.4886 11.4205 13.7865C11.4205 13.0728 11.4205 12.3592 11.4205 11.6456C11.4205 11.0984 11.4205 10.5531 11.4205 10.006C11.4205 9.77063 11.4377 9.52765 11.4166 9.29042C11.3688 8.74133 10.9154 8.32233 10.3682 8.31468C10.1214 8.31085 10.1214 8.69349 10.3682 8.69732C10.7394 8.70306 11.034 9.00152 11.0378 9.37268C11.0378 9.44921 11.0378 9.52574 11.0378 9.60036C11.0378 10.0213 11.0378 10.4422 11.0378 10.865C11.0378 11.5155 11.0378 12.166 11.0378 12.8145C11.0378 13.5263 11.0378 14.238 11.0378 14.9516C11.0378 15.5696 11.0378 16.1894 11.0378 16.8074C11.0378 17.1652 11.0378 17.5249 11.0378 17.8826C11.0378 18.007 11.0378 18.1256 10.9881 18.2442C10.8752 18.5197 10.6074 18.6594 10.3223 18.6594C9.87842 18.6594 9.43647 18.6594 8.99261 18.6594C8.29046 18.6594 7.58831 18.6594 6.88808 18.6594C6.42126 18.6594 5.95443 18.6594 5.48761 18.6594C5.24463 18.6594 5.01696 18.5848 4.86965 18.3762C4.77016 18.2327 4.7472 18.0759 4.7472 17.9075C4.7472 17.565 4.7472 17.2226 4.7472 16.882C4.7472 16.2717 4.7472 15.6614 4.7472 15.053C4.7472 14.3413 4.7472 13.6296 4.7472 12.9198C4.7472 12.2635 4.7472 11.6054 4.7472 10.9492C4.7472 10.513 4.7472 10.0767 4.7472 9.64053C4.7472 9.55444 4.7472 9.46834 4.7472 9.38034C4.74911 9.05126 4.97487 8.77385 5.2982 8.7088C5.40917 8.68584 5.53735 8.69923 5.65023 8.69923C5.88173 8.69923 6.11132 8.69923 6.34281 8.69923C7.02774 8.69923 7.71267 8.69923 8.39568 8.69923C8.96391 8.69923 9.53213 8.69923 10.1004 8.69923C10.1903 8.69923 10.2802 8.69923 10.3701 8.69923C10.615 8.69732 10.615 8.31468 10.3682 8.31468Z" fill="${color}"/>
            <path d="M7.89247 12.6311C7.37016 12.6273 6.87656 12.302 6.69672 11.8046C6.50922 11.2899 6.66419 10.7198 7.08318 10.3678C7.4907 10.0253 8.09527 9.98895 8.5487 10.2587C9.00022 10.5285 9.25276 11.0737 9.14945 11.5941C9.027 12.191 8.50278 12.6253 7.89247 12.6311C7.64567 12.633 7.64567 13.0156 7.89247 13.0137C8.59079 13.008 9.21067 12.5699 9.45365 11.9175C9.69088 11.2765 9.48426 10.5113 8.9543 10.0808C8.41286 9.63883 7.6361 9.56804 7.03344 9.93538C6.43461 10.3008 6.13232 11.0106 6.26816 11.6955C6.42121 12.4608 7.12145 13.008 7.89247 13.0137C8.13927 13.0156 8.13927 12.633 7.89247 12.6311Z" fill="${color}"/>
            <path d="M5.13973 6.35745C5.24495 6.25223 5.35592 6.15083 5.47263 6.05708C5.50132 6.03412 5.53002 6.00925 5.55872 5.98821C5.53385 6.00734 5.51089 6.02647 5.48602 6.04369C5.50132 6.03221 5.51472 6.02073 5.53002 6.01116C5.58933 5.96716 5.64864 5.92507 5.70986 5.88489C5.94136 5.72992 6.18816 5.59791 6.44645 5.48886C6.40053 5.50799 6.35461 5.52712 6.3087 5.54626C6.67603 5.3932 7.06059 5.28797 7.45471 5.2344C7.40305 5.24206 7.35331 5.24779 7.30165 5.25545C7.69386 5.20379 8.08989 5.20379 8.4821 5.25545C8.43044 5.24779 8.3807 5.24206 8.32904 5.2344C8.72316 5.28797 9.10772 5.39129 9.47505 5.54626C9.42914 5.52712 9.38322 5.50799 9.3373 5.48886C9.59367 5.59791 9.84048 5.72992 10.0739 5.88489C10.1351 5.92507 10.1944 5.96716 10.2537 6.01116C10.2863 6.03412 10.3685 6.10491 10.225 5.98821C10.2537 6.01116 10.2824 6.03412 10.3111 6.05708C10.4278 6.15274 10.5369 6.25223 10.644 6.35745C10.8564 6.56982 11.2448 6.58704 11.4552 6.35745C11.6657 6.12978 11.6829 5.77201 11.4552 5.54626C10.7359 4.83072 9.79265 4.3218 8.78821 4.15344C7.7436 3.97743 6.70282 4.11326 5.74047 4.5533C5.21434 4.79436 4.73413 5.14066 4.3247 5.54817C4.11234 5.76053 4.09703 6.15083 4.3247 6.35937C4.55811 6.56791 4.91206 6.58321 5.13973 6.35745Z" fill="${color}"/>
            <path d="M1.69737 4.48065C1.86765 4.31229 2.04175 4.14966 2.22351 3.99278C2.31151 3.91817 2.40144 3.84355 2.49136 3.77085C2.5124 3.75363 2.53536 3.73641 2.5564 3.71919C2.63102 3.65988 2.45118 3.79955 2.52771 3.74215C2.57554 3.7058 2.62337 3.66945 2.6712 3.63501C3.04045 3.36334 3.43074 3.12036 3.83634 2.90608C4.06592 2.78555 4.30125 2.67458 4.5404 2.57318C4.49448 2.59231 4.44857 2.61145 4.40265 2.63058C5.16793 2.30725 5.9753 2.08723 6.79798 1.97626C6.74633 1.98391 6.69658 1.98965 6.64493 1.99731C7.47143 1.88825 8.31133 1.88825 9.13783 1.99731C9.08618 1.98965 9.03644 1.98391 8.98478 1.97626C9.80937 2.08723 10.6148 2.30725 11.3801 2.63058C11.3342 2.61145 11.2883 2.59231 11.2424 2.57318C11.6594 2.75111 12.065 2.95774 12.4515 3.19306C12.6505 3.31359 12.8437 3.44178 13.0331 3.57761C13.0771 3.61014 13.123 3.64266 13.167 3.67519C13.19 3.69241 13.2111 3.70771 13.234 3.72493C13.2455 3.73258 13.2551 3.74215 13.2665 3.7498C13.322 3.79189 13.1613 3.66754 13.2168 3.71154C13.3067 3.78424 13.3985 3.85503 13.4866 3.92964C13.6951 4.10375 13.8941 4.28933 14.0873 4.48065C14.2997 4.69301 14.69 4.71023 14.8985 4.48065C15.109 4.25106 15.1262 3.89521 14.8985 3.66945C14.1734 2.94626 13.3335 2.32638 12.419 1.85956C11.5332 1.40804 10.5823 1.08279 9.60275 0.918257C8.62701 0.753722 7.63788 0.719284 6.65832 0.849382C5.62519 0.98522 4.63797 1.26646 3.68902 1.70267C2.76303 2.12932 1.90783 2.71476 1.15785 3.40543C1.0641 3.49152 0.97227 3.57953 0.882349 3.66945C0.669983 3.88181 0.654678 4.27211 0.882349 4.48065C1.11385 4.69301 1.4697 4.70832 1.69737 4.48065Z" fill="${color}"/>
        </svg>
    </div>`
}


export const navTabStyles = {
    p: 0.3,
    [`& .${tabsClasses.scrollButtons}`]: {
        '&.Mui-disabled': { opacity: 0.3 },
    },
}

export const barChartStyles = `
        .apexcharts-legend-series {
            display: flex;
            flex-direction: row-reverse; 
            align-items: center;
        }
        .apexcharts-legend-text {
            padding-right: 5px; 
        }
        .apexcharts-legend {
            right : 0 !important;
        }
    `;

export const getStateItems = (chartData) => [
    { icon: <ActiveIcon />, label: 'Connected', count: chartData?.Connected, color: theme.palette.success.main },
    { icon: <WarningIcon />, label: 'Disconnected', count: chartData?.Disconnected, color: theme.palette.error.main },
    { icon: <HeldIcon />, label: 'Activated', count: chartData?.Activated, color: theme.palette.secondary.main },
    { icon: <TemporaryIcon />, label: 'Registered', count: chartData?.Registered, color: theme.palette.secondary.light },
];

export const prepareWindowsCommand = (token) => {
    return `Invoke-WebRequest '${process.env.REACT_APP_SOCKET_URL}file-download/binary/getExe/${process.env.REACT_APP_PS_SCRIPT}' -OutFile "init-script-download.ps1";Invoke-Command  -ScriptBlock { & "./init-script-download.ps1" -token ${token}};Remove-Item -Path "./init-script-download.ps1";`
}

const SCRIPT_ENUMS = {
    windows: {
        general: process.env.REACT_APP_PS_SCRIPT,
    },
    ubuntu: {
        general: process.env.REACT_APP_UBUNTU_24_SCRIPT,
        ubuntu20: process.env.REACT_APP_UBUNTU_20_SCRIPT
    }
}

export const prepareUbuntuCommand = (token, osVersion) => {
    switch (osVersion) {
        case "ubuntu24.04":
            return `curl -o init.sh ${process.env.REACT_APP_SOCKET_URL}file-download/binary/getExe/${SCRIPT_ENUMS.ubuntu.general} && chmod +x init.sh && ./init.sh ${token}`
        case "ubuntu22.04":
        case "ubuntu20.04":
            return `curl -o init.sh ${process.env.REACT_APP_SOCKET_URL}file-download/binary/getExe/${SCRIPT_ENUMS.ubuntu.ubuntu20} && chmod +x init.sh && ./init.sh ${token}`
        default:
            return `curl -o init.sh ${process.env.REACT_APP_SOCKET_URL}file-download/binary/getExe/${SCRIPT_ENUMS.ubuntu.general} && chmod +x init.sh && ./init.sh ${token}`
    }
}

export const prepareCentOSCommand = (token) => {
    return `curl -o init.sh ${process.env.REACT_APP_SOCKET_URL}file-download/binary/getExe/${process.env.REACT_APP_CENTOS_SCRIPT} && chmod +x init.sh && ./init.sh ${token}`
}

export const prepareKaliCommand = (token) => {
    return `curl -o init.sh ${process.env.REACT_APP_SOCKET_URL}file-download/binary/getExe/${process.env.REACT_APP_KALI_SCRIPT} && chmod +x init.sh && ./init.sh ${token}`
}
export const osOptions = [
    { value: 'windows', label: 'Windows' },
    { value: 'ubuntu', label: 'Ubuntu' },
    // { value: 'centos', label: 'CentOS' },
    // { value: 'kali', label: 'Kali Linux' },
];

export const windowsVersions = [
    { value: 'windows11', label: 'Windows 11' },
    { value: 'windows10', label: 'Windows 10' },
];


export const ubuntuVersions = [
    { value: 'ubuntu24.04', label: 'Ubuntu 24.04 LTS' },
    { value: 'ubuntu22.04', label: 'Ubuntu 22.04 LTS' },
    { value: 'ubuntu20.04', label: 'Ubuntu 20.04 LTS' },
];

export const centosVersions = [
    { value: 'centos8', label: 'CentOS Stream 9' },
    { value: 'centos7', label: 'CentOS Stream 8' },
    { value: 'centos7', label: 'CentOS Linux 7' },
];

export const kaliVersions = [
    { value: 'kali2024.4', label: 'Kali Linux 2024.4' },
    { value: 'kali2024.3', label: 'Kali Linux 2024.3' },
    { value: 'kali2024.2', label: 'Kali Linux 2024.2' },
];

export const selectMenuOptions = [
    { value: "All", label: "All" },
    { value: "High", label: "High" },
    { value: "Medium", label: "Medium" },
    { value: "Low", label: "Low" },
]


export const getDeviceColumns = ({
    dispatch,
    isTwoFaEnabled,
    setIs2FAOpen,
    user,
    handleClose,
    anchorEl,
    handleOpenMenu,
    menuRowId,
    isConsoleAllowed
}
) => [
        {
            field: "deviceId",
            headerName: "ID",
            width: 150,

        },
        {
            field: "deviceName",
            headerName: "Device Name",
            width: 170,
            editable: true
        },
        {
            field: "assetId",
            headerName: "Asset ID",
            width: 100,

        },
        {
            field: "systemDetails.ip",
            headerName: "IP",
            width: 130,

            renderCell: (params) => {
                const ip = params?.row?.systemDetails?.ip;
                const maskedIp = user.role === 'admin' || user?.isTwoFaVerified || !user?.isTwoFaEnabled ? ip : ip?.replace(/\d{1,3}$/, 'xx');
                return <p>{maskedIp}</p>;
            },
        },
        {
            field: "os",
            headerName: "OS",
            width: 100,

            renderCell: (params) => <p>{params?.row?.systemDetails?.os}</p>,
        },
        {
            field: "lastAuthenticated",
            headerName: "Last Authenticated",
            width: 180,
            renderCell: (params) => formatDateBdata(params?.row?.lastAuthenticated)
        },
        {
            field: "status",
            headerName: "Status",
            width: 100,

            renderCell: (params) => getBadge(params?.row?.status),
        },
        {
            field: "lastActive",
            headerName: "Last Active",
            width: 180,
            renderCell: (params) => formatDateBdata(params?.row?.lastActive)

        },
        isConsoleAllowed && {
            field: "remoteAccess",
            headerName: "Remote Access",
            width: 150,

            renderCell: (params) => (
                <Button
                    variant="contained"
                    onClick={async (event) => {
                        if (params?.row?.status !== DeviceStatus.connected || params?.row?.status === DeviceStatus.quarantine) {
                            toast.error("Cannot open remote console: Device is not connected.");
                            event.stopPropagation();
                            return;
                        }
                        dispatch(devicesActions.actions.setSelectedDevice(params?.row));
                        if (!isTwoFaEnabled || user?.role === 'admin' || user?.isTwoFaVerified) {
                            openRemoteConsole(params?.row?._id);
                        } else {
                            const paylaod = { user }
                            dispatch({ type: SEND_TWO_FA_OTP, paylaod })
                            setIs2FAOpen(true);
                        }
                        event.stopPropagation();
                    }}
                    className={tables.actionBtn}
                    size="small"
                >
                    Console
                </Button>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 100,
            renderCell: (params) => {
                return (
                    <div>
                        <IconButton
                            onClick={(e) => handleOpenMenu(e, params.id)}
                            sx={{ p: 0 }}
                        >
                            <MoreVert />
                        </IconButton>
                        <Menu
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            anchorEl={anchorEl}
                            open={menuRowId === params.id}
                            onClose={handleClose}
                            TransitionComponent={Fade}
                        >
                            {params.row.status === DeviceStatus.registered ?
                                <MenuItem onClick={(e) => handleClose(e, "install", params.row)}>
                                    Install
                                </MenuItem>
                                :
                                <MenuItem onClick={(e) => handleClose(e, "txn", params.row)}>
                                    Txn
                                </MenuItem>
                            }
                            {params.row.status !== DeviceStatus.registered ?
                                <MenuItem onClick={(e) => handleClose(e, "status", params.row)}>
                                    {params.row?.status === DeviceStatus.quarantine ? "Re-Connect" : "Quarantine"}
                                </MenuItem>
                                : null}

                            {/* <Button
                            variant="contained"
                            onClick={(event) => {
                                handleActionClick(params?.row, handleInstallDevice);
                                event.stopPropagation();
                                }}
                                className={tables.actionBtn}
                                size="small"
                                >
                                {params.row.status === DeviceStatus.registered ? "Install" : "Txn"}
                                </Button> */}
                        </Menu>

                    </div>
                )
            },
        },
    ];

export const DEVICE_DOWNLOAD_COLS = [
    { headerName: "ID", field: "deviceId", },
    { headerName: "Device Name", field: "deviceName" },
    { headerName: "Asset ID", field: "assetId" },
    { headerName: "IP", field: "systemDetails.ip", nested: true },
    { headerName: "OS", field: "systemDetails.os", nested: true },
    { headerName: "Last Authenticated", field: "lastAuthenticated", type: "date" },
    { headerName: "Status", field: "status" },
    { headerName: "Last Active", field: "lastActive", type: "date" }
];


export const handleActionClick = (row, callBack1) => {
    if (row?.status === DeviceStatus.registered) {
        callBack1(row?.token);
    } else {
        handleOpenBlockHash(row?.assetIdTxn)
    }
};